export const isDesktop = useMedia("(min-width: 1024px)");
